<script setup lang="ts">
import { RouterLink } from 'vue-router'

interface Props {
  params?: { data?: { uuid?: string; internalReference?: string | number } }
}

defineProps<Props>()
</script>

<template>
  <RouterLink
    v-if="params?.data?.uuid"
    :to="`/tickets/${params.data.uuid}`"
    class="link link-primary hover:underline font-medium"
  >
    #{{ params.data.internalReference ?? '-' }}
  </RouterLink>
  <span v-else>#{{ params?.data?.internalReference ?? '-' }}</span>
</template>
